import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { ENUMS } from '../../utils/constants';
import SecurityService from '../../services/SecurityService';
import { configs, isNullOrEmpty, translate } from '../../utils/util';
import ConfigurationService from '../../services/ConfigurationService';
import SelectNew from './SelectNew';

const SelectResourceUI = (props) => {
    const [resources, setResources] = useState([]);

    useEffect(() => {
        if (!props.resources || props.resources.length <= 0) {
            props.getResourcesAll();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!loadShedRequired()) {
            setResources([...filterPrint()])
        } else if (props.resources && props.sheds && props.filterArea && !isNullOrEmpty(props.shedId)) {
            setResources([...filterPrintShed()]);
        } else if (!props.filterArea) {
            setResources([...filterPrint()])
        }
        // eslint-disable-next-line
    }, [props.shedId, props.sheds, props.resources, props.value]);

    const loadConfigLabelLaser = () => {
        if (props.loadConfigLaser) {
            return Boolean(props.loadConfigLaser)
        }

        return Boolean(configs(ENUMS.eModules.PhysicalConfirmation.value, props.config?.items)?.generateLabelLaser)
    }

    const loadShedRequired = () => {
        const configItem = configs(ENUMS.eModules.PhysicalConfirmation.value, props.config?.items);
        return Boolean(configItem?.shedRequiredPhysicalConfirmation)
    }

    const filterPrint = () => {
        let laser = !isNullOrEmpty(props.printLaser);
        setResourcePrinter(props.value);
        if (loadConfigLabelLaser() && !laser) {
            return props.resources;
        }

        return props.resources.filter((f) => f.printer.laser === laser) || [];
    }

    const filterPrintShed = () => {
        let laser = !isNullOrEmpty(props.printLaser);
        var shed = props.sheds.find((i) => i.id === props.shedId);
        setResourcePrinter(props.value);
        if (loadConfigLabelLaser() && !laser) {
            return props.resources;
        }
        return props.resources.filter((f) => f.printer.laser === laser && f.resourceAreas.includes(Number(shed?.areaId))) || [];
    }

    const setResourcePrinter = (value) => {
        let laser = !isNullOrEmpty(props.printLaser);
        if (!isNullOrEmpty(value)) {
            let resourceFilter = props.resources.find((i) => i.resourceId === Number(value));
            if (!laser) {
                props.setResource(value, resourceFilter);
                props.setPrinter(resourceFilter?.printer);
            } else {
                props.setPrinter(resourceFilter?.printer);
            }
        }
    }

    const onChangeResource = (el) => {
        if (!isNullOrEmpty(el.target.value)) {
            setResourcePrinter(el.target.value);
        }
        else {
            props.setResource("", null)
            props.setPrinter();
        }

        if (props.onChange) {
            props.onChange(el);
        }
    }

    return (
        <SelectNew
            required={props.required}
            id={props.id || 'resource'}
            name={props.id || 'resource'}
            valuefield="resourceId"
            value={props.value}
            display="name"
            label={props.printLaser ? "Recurso Laser" : translate('resource', 'physical-confirmation')}
            placeHolder={translate('choose-one-option', 'general')}
            data={resources || []}
            change={onChangeResource}
        />
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        sheds: state.configReducer.sheds,
        resource: state.configReducer.resource,
        resources: state.logisticsResourceReducer.list,
        config: state.configReducer.config,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setResource: (resource, resourceObj) => {
            dispatch(SecurityService.setResource(resource, resourceObj));
        },
        setPrinter: (printer) => {
            dispatch(SecurityService.setPrinter(printer));
        },
        getResourcesAll: (vision, filter) => {
            dispatch(ConfigurationService.getResourcesAll(vision, filter));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SelectResourceUI));
